import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function Navbar() {
  const { logout } = useAuth();
  const tabs = [
    { to: "/dashboard/home", label: "Procesar" },
    { to: "/dashboard/profile", label: "Perfil" },
    { to: "/dashboard/settings", label: "Ajustes" },
  ];

  return (
    <nav className="bg-white shadow p-4 flex justify-between">
      <div className="space-x-4">
        {tabs.map(tab => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              isActive
                ? "text-blue-600 font-semibold"
                : "text-gray-600 hover:text-blue-500"
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      <button
        onClick={logout}
        className="text-red-500 hover:text-red-700"
      >
        Cerrar Sesión
      </button>
    </nav>
  );
}
